import React from 'react';
import SortView from '../../Community/LoveSection/SortView';
import FilterView from '../../Community/LoveSection/FilterView';
import MobileFilterView from '../../Community/LoveSection/MobileFilterView';
import { useSelector } from 'react-redux';

const LoveFilterTopNav = () => {
  const isCurrentUserRegistered = useSelector(
    ({ love }) => love?.isCurrentUserRegistered
  );
  const width = window?.innerWidth;
  return (
    <div className='w-full pb-[0px] shadow-md mt-[16px]'>
      <div className='responsive-width-margin '>
        <div className='py-3'>
          <div className='flex flex-col md:flex-row md:items-center md:justify-between'>
            {isCurrentUserRegistered?.quiz_taken ? (
              <SortView />
            ) : (
              <>
                {width > 600 && isCurrentUserRegistered !== null && (
                  <FilterView />
                )}
                {width < 600 && isCurrentUserRegistered !== null && (
                  <div className='mr-2 sm:hidden'>
                    <MobileFilterView />
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoveFilterTopNav;
